import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const ProtectedRoute = ({ children, requireTenant = true, superAdminOnly = false }) => {
  const { user, loading, isSuperAdmin, isImpersonating, activeTenant } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
          <p className="mt-4 text-muted-foreground">Carregando...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // /platform routes
  if (superAdminOnly && !isSuperAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  // Tenant-scoped routes
  if (requireTenant) {
    // Super admin without impersonation must go to /platform
    if (isSuperAdmin && !isImpersonating) {
      return <Navigate to="/platform" replace />;
    }
    // Non-super-admin user must have a tenant (sanity check)
    if (!isSuperAdmin && !activeTenant && !user.tenant_id) {
      return <Navigate to="/login" replace />;
    }
    // Force onboarding for fresh tenant owners
    if (
      user.role === 'admin' &&
      user.onboarding_completed === false &&
      location.pathname !== '/onboarding'
    ) {
      return <Navigate to="/onboarding" replace />;
    }
  }

  return children;
};
